import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { save, load } from "redux-localstorage-simple";
import rootReducer from "./reducers/combineReducer";

//import { composeWithDevTools } from "redux-devtools-extension";

const store = createStore(
    rootReducer,
    load(),
    applyMiddleware(thunk, save())
);

export default store;